import { Tools } from '@carbon/pictograms-react';
import * as React from 'react';
export default {
  Tools,
  React
};